import { AccountingDirectoryControlsComponent } from '../../shared/accounting-directory-controls.component';
import { isEditableFinancialDraft } from '../../shared/accounting-draft-eligibility';
// generated-vouchers.component.ts
import { Component, OnInit } from '@angular/core';
import { FinancePdfViewButtonComponent } from '../../finance-pdf-view-button.component';
import { AccountsService } from '../../accounts.service';
import { MessageService, MenuItem } from "primeng/api";
import { Router } from "@angular/router";
import { SessionStorageService } from "../../../services/session-storage.service";
import { PaymentService } from "../../../services/payment.service";
import { PaymentTransactions } from "../../payment-transactions/payment-transactions.model";
import { Voucher } from "./voucher.model";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import * as XLSX from "xlsx";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ToastModule } from "primeng/toast";
import { ProgressBarModule } from "primeng/progressbar";
import { PanelModule } from "primeng/panel";
import { ImageModule } from "primeng/image";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { IftaLabelModule } from "primeng/iftalabel";
import { DrawerModule } from "primeng/drawer";
import { PermissionService } from '../../../security/permission.service';
import { app_permissions } from '../../../security/app-permissions';
import { PageShellComponent } from '../../../shared/page-layout/page-shell.component';
import { PageHeroComponent } from '../../../shared/page-layout/page-hero.component';
import { PageMetricStripComponent } from '../../../shared/page-layout/page-metric-strip.component';
import { PageSearchPanelComponent } from '../../../shared/page-layout/page-search-panel.component';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { PageMetric } from '../../../shared/page-layout/page-layout.models';
import { CompanyScopeSelection, CompanyScopeSelectorComponent } from '../../company-scope-selector/company-scope-selector.component';
import { CRM_PAYABLE_ROLES, CrmPartyContextService } from '../../../shared/crm-client-contact-picker/crm-party-context.service';
import { finalize } from 'rxjs';
import { PendingActionTracker } from '../../../shared/state/pending-action-tracker';


@Component({
    selector: 'app-generated-vouchers',
    templateUrl: './generated-vouchers.component.html',
    styleUrls: ['../../finance-list.shared.css', './generated-vouchers.component.css'],
    standalone: true,
    imports: [FinancePdfViewButtonComponent,
        CommonModule,
        FormsModule,
        BreadcrumbModule,
        TableModule,
        MultiSelectModule,
        DatePickerModule,
        InputTextModule,
        ButtonModule,
        CardModule,
        TooltipModule,
        TagModule,
        ToastModule,
        ProgressBarModule,
        PanelModule,
        ImageModule,
        InputGroupModule,
        InputGroupAddonModule,
        IftaLabelModule,
        DrawerModule,
        PageShellComponent,
        PageHeroComponent,
        PageMetricStripComponent,
        PageSearchPanelComponent,
        PageDataPanelComponent,
        AccountingDirectoryControlsComponent,
        CompanyScopeSelectorComponent
    ],
    providers: [
        MessageService,
        AccountsService,
        SessionStorageService,
        PaymentService
    ]
})
export class GeneratedVouchersComponent implements OnInit {
    readonly pendingStatuses = ['DRAFT', 'SUBMITTED', 'APPROVED', 'ON_HOLD'];
    selectedDocumentStatuses: string[] = this.pendingStatuses.slice();
    searchText = '';
    directoryMode: 'LIST' | 'CRM' | 'PARTY_TYPE' = 'LIST';
    directoryFilters: Record<string, string | number | boolean | number[] | string[] | null | undefined> = {};
    private listRequestId = 0;

    readonly documentActions = new PendingActionTracker<number | undefined>();

    homeBreadcrumb: MenuItem = { icon: 'pi pi-home', routerLink: '/' };
    breadcrumbItems: MenuItem[] = [];
    isLoading = false;
    first = 0;
    rows = 20;

    // Data properties
    allVouchers: Voucher[] = [];
    selectedVouchers: Voucher[] = [];
    totalRecords: number = 0;

    // Filter properties
    clients: any[] = [];
    selectedClients: any[] = [];
    dateRange: (Date | null)[] | null = null;
    statuses: { label: string, value: string }[] = [
        { label: 'Applied', value: 'APPLIED' },
        { label: 'Partially Applied', value: 'PARTIALLY_APPLIED' },
        { label: 'Unapplied', value: 'UNAPPLIED' }
    ];
    selectedStatuses: string[] = [];
    voucherNumberFilter: string | null = null;
    paymentTransactionNumberFilter: string | null = null;

    // Summary Card properties
    totalUnappliedAmount: number = 0;
    totalAppliedAmount: number = 0;
    reportCurrencyCode: string = 'USD';

    canCreateVoucher = false;
    canApplyVoucher = false;
    canRegisterPayment = false;
    previewVoucher: Voucher | null = null;
    isPreviewVisible = false;
    currentScope: CompanyScopeSelection | null = null;

    get isConsolidatedReadOnly(): boolean {
        return !!this.currentScope?.readOnly;
    }

    constructor(
        private accountsService: AccountsService,
        private messageService: MessageService,
        private paymentService: PaymentService,
        private router: Router,
        private sessionStorageService: SessionStorageService,
        private permissionService: PermissionService,
        public crmPartyContext: CrmPartyContextService
    ) { }

    ngOnInit(): void {
        this.canCreateVoucher = this.permissionService.hasPermission(app_permissions.accounts.voucher.create);
        this.canApplyVoucher = this.permissionService.hasPermission(app_permissions.accounts.voucher.edit);
        this.canRegisterPayment = this.permissionService.hasPermission(app_permissions.accounts.voucher.edit);

        this.breadcrumbItems = [
            { label: 'Accounts' },
            { label: 'Enterprise' },
            { label: 'Payables' },
            { label: 'Generated Vouchers' }
        ];
        this.loadInitialData();
    }

    onScopeChange(scope: CompanyScopeSelection) {
        this.currentScope = scope;
        this.selectedVouchers = [];
        this.applyFilters();
    }

    loadInitialData() {
        this.isLoading = true;
        const companyId = this.sessionStorageService.getCompany()?.id;
        if (!companyId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Company not found.' });
            this.isLoading = false;
            return;
        }

        this.crmPartyContext.loadClients(companyId, CRM_PAYABLE_ROLES).subscribe(clients => {
            this.clients = clients.map(client => ({ ...client, name: this.crmPartyContext.clientName(client) }));
        });

        // Initial data load for the table and summary is triggered by applyFilters
        this.applyFilters();
    }

    loadData(event: TableLazyLoadEvent) {
        this.isLoading = true;
        const requestId = ++this.listRequestId;
        this.first = event.first ?? 0;
        this.rows = event.rows ?? 20;

        const sessionCompanyId = this.sessionStorageService.getCompany()?.id;
        const companyGroupId = this.currentScope?.companyGroupId;
        const companyId = companyGroupId ? undefined : (this.currentScope?.companyId ?? sessionCompanyId);
        if (!companyId && !companyGroupId) {
            this.isLoading = false;
            return;
        }

        const clientIds = this.selectedClients.map(c => Number(c.id?.entityId ?? c.id)).filter(Boolean);
        const startDate = this.dateRange?.[0] ? this.dateRange[0].toISOString() : undefined;
        const endDate = this.dateRange?.[1] ? this.dateRange[1].toISOString() : undefined;

        // Phase 1 debt: voucher allocation status is still derived from linked bills in the current page payload.
        // Later phases must move status/open-amount filtering fully behind backend-authoritative allocation fields.
        this.directoryFilters = { companyId, companyGroupId, clientIds, startDate, endDate, statuses: this.selectedStatuses, voucherNumber: this.voucherNumberFilter, paymentTransactionNumber: this.paymentTransactionNumberFilter, searchText: this.searchText };

        this.accountsService.getGeneratedVouchers(
            this.first / this.rows,
            this.rows,
            companyId,
            clientIds,
            this.selectedStatuses,
            startDate,
            endDate,
            this.voucherNumberFilter ?? undefined,
            this.paymentTransactionNumberFilter ?? undefined,
            companyGroupId,
            this.selectedDocumentStatuses,
            this.searchText
        ).subscribe({
            next: (dataWrapper) => {
                if (requestId !== this.listRequestId) return;
                this.allVouchers = dataWrapper.items.map(r => {
                    const appliedAmount = this.getAppliedAmount(r);
                    const unappliedAmount = (r.amount || 0) - appliedAmount;
                    let status: 'APPLIED' | 'PARTIALLY_APPLIED' | 'UNAPPLIED';

                    if (unappliedAmount <= 0.01) { // Use a small epsilon for float comparison
                        status = 'APPLIED';
                    } else if (appliedAmount > 0) {
                        status = 'PARTIALLY_APPLIED';
                    } else {
                        status = 'UNAPPLIED';
                    }

                    return {
                        ...r,
                        status: status
                    };
                });
                this.totalRecords = dataWrapper.count;
                this.isLoading = false;
            },
            error: (err) => {
                if (requestId !== this.listRequestId) return;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not load vouchers.' });
                this.isLoading = false;
            }
        });

        // Fetch filtered summary
        this.accountsService.getGeneratedVouchersSummary(
            companyId,
            clientIds,
            this.selectedStatuses,
            startDate,
            endDate,
            this.voucherNumberFilter ?? undefined,
            this.paymentTransactionNumberFilter ?? undefined,
            companyGroupId
        ).subscribe(summary => {
                if (requestId !== this.listRequestId) return;
            this.totalAppliedAmount = summary.totalAppliedAmount || 0;
            this.totalUnappliedAmount = summary.totalUnappliedAmount || 0;
            if (summary.currencyCode) {
                this.reportCurrencyCode = summary.currencyCode;
            }
        });
    }

    onDirectoryModeChange(mode: 'LIST' | 'CRM' | 'PARTY_TYPE'): void {
        this.directoryMode = mode;
        this.selectedVouchers = [];
    }

    onDirectorySearch(value: string): void {
        this.searchText = value;
        this.selectedVouchers = [];
        this.applyFilters();
    }

    showPendingStatuses(): void {
        this.selectedDocumentStatuses = this.pendingStatuses.slice();
        this.applyFilters();
    }

    showAllStatuses(): void {
        this.selectedDocumentStatuses = [];
        this.applyFilters();
    }

    applyFilters() {
        this.loadData({ first: 0, rows: this.rows });
    }

    clearFilters() {
        this.selectedDocumentStatuses = this.pendingStatuses.slice();
        this.selectedClients = [];
        this.dateRange = null;
        this.selectedStatuses = [];
        this.voucherNumberFilter = null;
        this.paymentTransactionNumberFilter = null;
        this.searchText = '';
        this.applyFilters();
    }

    get metrics(): PageMetric[] {
        return [
            { label: 'Unapplied amount', value: this.formatMoney(this.totalUnappliedAmount), hint: 'Existing summary endpoint', tone: 'warn' },
            { label: 'Applied amount', value: this.formatMoney(this.totalAppliedAmount), hint: 'Existing summary endpoint', tone: 'success' },
            { label: 'Selected amount', value: this.formatMoney(this.getSelectedTotal()), hint: `${this.selectedVouchers.length} selected`, tone: 'info' },
            { label: 'Records', value: this.totalRecords, hint: 'Backend count' }
        ];
    }

    get activeFilterCount(): number {
        return [
            this.selectedClients.length,
            this.dateRange?.some(Boolean) ? 1 : 0,
            this.selectedStatuses.length,
            this.voucherNumberFilter ? 1 : 0,
            this.paymentTransactionNumberFilter ? 1 : 0
        ].reduce((total, value) => total + Number(value), 0);
    }

    get resultText(): string {
        return `${this.totalRecords} vouchers`;
    }

    getSelectedTotal(): number {
        return this.selectedVouchers.reduce((total, voucher) => total + (voucher.amount || 0), 0);
    }

    formatMoney(amount: number | undefined, currencyCode: string = this.reportCurrencyCode): string {
        return `${currencyCode || ''} ${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`;
    }

    private errorMessage(error: any, fallback: string): string {
        return error?.error?.message || error?.message || fallback;
    }

    statusSeverity(status: string | undefined): 'success' | 'info' | 'warn' | 'danger' | 'secondary' {
        if (status === 'APPLIED') return 'success';
        if (status === 'PARTIALLY_APPLIED') return 'warn';
        if (status === 'UNAPPLIED') return 'danger';
        if (status === 'POSTED' || status === 'APPROVED' || status === 'CLOSED') return 'success';
        if (status === 'DRAFT' || status === 'SUBMITTED') return 'info';
        if (status === 'ON_HOLD') return 'warn';
        if (status === 'CANCELLED' || status === 'VOIDED' || status === 'REVERSED') return 'danger';
        return 'secondary';
    }

    openPreview(voucher: Voucher) {
        this.previewVoucher = voucher;
        this.isPreviewVisible = true;
    }

    canEditDraft(voucher: Voucher): boolean {
        return !this.isConsolidatedReadOnly && !!voucher.voucherId
            && this.permissionService.hasPermission(app_permissions.accounts.voucher.edit)
            && isEditableFinancialDraft(voucher, this.sessionStorageService.getCompany()?.id);
    }

    editDraft(voucher: Voucher): void {
        if (this.canEditDraft(voucher)) this.router.navigate(['/accounts/enterprise/payables/generated-vouchers/edit', voucher.voucherId]);
    }

    viewVoucher(voucher: Voucher) {
        this.router.navigate(['/accounts/enterprise/payables/generated-vouchers/view', voucher.voucherId]);
    }

    exportToExcel() {
        if (this.allVouchers.length === 0) {
            this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'There is no data to export.' });
            return;
        }
        const worksheet = XLSX.utils.json_to_sheet(this.allVouchers.map(r => ({
            Vendor: this.crmPartyContext.displayName(r),
            Contact: this.crmPartyContext.contactDisplayName(r),
            'Voucher #': r.voucherNumber,
            'Voucher Date': r.voucherDate,
            'Total Amount': r.amount,
            'Applied Amount': this.getAppliedAmount(r),
            'Un-Applied Amount': this.getUnAppliedAmount(r),
            Currency: r.country?.currencyCode,
            Status: r.status,
            'Linked Bills': r.bills?.map(bill => bill.billNumber).join(', '),
            'Payment Txn #': r.paymentTransactionNumber
        })));
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "GeneratedVouchersExport");
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        const url = window.URL.createObjectURL(data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName + '_' + new Date().getTime() + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
    }

    generatePaymentFromVouchers() {
        if (this.isConsolidatedReadOnly) {
            this.messageService.add({ severity: 'warn', summary: 'Read-only scope', detail: 'Switch to a legal company to register payments.' });
            return;
        }
        this.isLoading = true;
        if (!this.selectedVouchers || this.selectedVouchers.length === 0) {
            this.messageService.add({ severity: 'error', summary: 'Invalid selection', detail: 'No vouchers selected.' });
            this.isLoading = false;
            return;
        }
        if (this.selectedVouchers.some(r => r.paymentTransactionNumber != null)) {
            this.messageService.add({ severity: 'error', summary: 'Invalid selection', detail: 'Selected Vouchers contain already paid vouchers.' });
            this.isLoading = false;
            return;
        }
        this.paymentService.generatePaymentFromVouchers(this.selectedVouchers, this.sessionStorageService.getCustomer()?.firebaseId ?? '').subscribe({
            next: (paymentTransaction: PaymentTransactions) => {
                console.log('Payment Transaction from Vouchers:', paymentTransaction);
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Payment generated successfully.' });
                this.applyFilters(); // Refresh data
            },
            error: (error) => {
                console.error('Error generating payment:', error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: this.errorMessage(error, 'Failed to generate payment.') });
                this.isLoading = false;
            }
        });
    }

    createVoucher() {
        if (this.isConsolidatedReadOnly) {
            this.messageService.add({ severity: 'warn', summary: 'Read-only scope', detail: 'Switch to a legal company to create vouchers.' });
            return;
        }
        this.router.navigate(['/accounts/enterprise/payables/generated-vouchers/add']);
    }

    applyVoucherOnBill() {
        if (this.isConsolidatedReadOnly) {
            this.messageService.add({ severity: 'warn', summary: 'Read-only scope', detail: 'Switch to a legal company to apply vouchers.' });
            return;
        }
        if (!this.selectedVouchers || this.selectedVouchers.length === 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a voucher to apply.' });
            return;
        }
        if (this.selectedVouchers.length > 1) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select only one voucher to apply.' });
            return;
        }
        const voucher = this.selectedVouchers[0];
        if (this.getUnAppliedAmount(voucher) <= 0) {
            this.messageService.add({ severity: 'warn', summary: 'Already Applied', detail: 'This voucher is already fully applied.' });
            return;
        }
        this.router.navigate(['/accounts/enterprise/payables/apply-vouchers-bill', voucher.voucherId]);
    }

    getAppliedAmount(voucher: Voucher): number {
        return voucher.allocatedAmount ?? voucher.bills?.reduce((acc, bill) => acc + (bill.allocatedAmount ?? bill.totalAmount ?? 0), 0) ?? 0;
    }

    getUnAppliedAmount(voucher: Voucher): number {
        return voucher.openAmount ?? Math.max(0, (voucher.amount || 0) - this.getAppliedAmount(voucher));
    }

    downloadVoucher(voucher: Voucher) {
        if (!voucher.voucherId || !this.documentActions.begin(voucher.voucherId)) return;
        this.accountsService.downloadVoucherDocument(voucher.voucherId).pipe(
            finalize(() => this.documentActions.end(voucher.voucherId))
        ).subscribe({
            next: pdf => this.accountsService.downloadPdfDocument(pdf, 'voucher', voucher.voucherNumber, voucher.voucherId, voucher.postingStatus),
            error: err => this.messageService.add({ severity: 'error', summary: 'Document unavailable', detail: err?.status === 404 ? 'Original unavailable: no stored voucher PDF exists.' : 'The voucher PDF is unavailable.' })
        });
    }
}
